import React, { Fragment, memo } from 'react';
import RacketBall from 'svg/RacketBall';
import classNames from 'styles/utils/classNames';
import VenueClinicsPopup from './VenueClinicsPopup';
import { ClinicType } from '../props';

const MemoizedRacket = memo(RacketBall);

interface VenueClinicMapMarkerProps {
  venueId: string;
  venueName: string;
  clinics: ClinicType[];
  lat: number;
  lng: number;
  listHoveredVenueId: string | null;
  setListHoveredVenueId: React.Dispatch<React.SetStateAction<string | null>>;
  setActiveVenueId: React.Dispatch<React.SetStateAction<string | null>>;
  activeVenueId: string | null;
  onClinicClick: (clinic: ClinicType) => void;
}

const VenueClinicMapMarker: React.FC<VenueClinicMapMarkerProps> = ({
  venueId,
  venueName,
  clinics,
  listHoveredVenueId,
  setListHoveredVenueId,
  setActiveVenueId,
  activeVenueId,
  onClinicClick,
}) => {
  const isActive = activeVenueId === venueId;
  const isHovered = listHoveredVenueId === venueId;
  const clinicCount = clinics.length;

  return (
    <Fragment>
      <div
        onClick={() => setActiveVenueId(isActive ? null : venueId)}
        onMouseLeave={() => setListHoveredVenueId(null)}
        onMouseEnter={() => setListHoveredVenueId(venueId)}
        className={classNames(
          'group relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-full shadow-[0px_4px_4px_0px_rgba(0,0,0,0.16)] transition-[background-color]',
          isHovered || isActive
            ? 'z-20 bg-color-bg-lightmode-brand text-color-text-lightmode-invert dark:bg-color-bg-lightmode-brand dark:text-color-text-lightmode-invert'
            : 'bg-color-bg-lightmode-primary text-color-text-lightmode-secondary dark:bg-color-bg-darkmode-primary dark:text-color-text-darkmode-secondary',
        )}
      >
        <MemoizedRacket className="h-5 w-5" />
        {clinicCount > 1 && (
          <div
            className={classNames(
              'absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-semibold',
              isHovered || isActive
                ? 'bg-color-text-lightmode-invert text-color-bg-lightmode-brand'
                : 'bg-color-brand-primary text-color-text-lightmode-invert',
            )}
          >
            {clinicCount}
          </div>
        )}
      </div>
      {isActive && (
        <VenueClinicsPopup
          venueId={venueId}
          venueName={venueName}
          clinics={clinics}
          onClose={() => setActiveVenueId(null)}
          onClinicClick={onClinicClick}
        />
      )}
    </Fragment>
  );
};

export default VenueClinicMapMarker;
